<template>
  <div class="wrap">
    <!-- <Header :class="`${fixedHeader ? 'fixedHeader' : 'absoluteHeader'}`" /> -->
    <Header :class="`${'fixedHeader'}`" />
    <div class="banner" style="height: 70px">
      <!-- <img v-lazy="imgObj" alt="" /> -->
    </div>
    <div class="main">
      <p class="credit-title">{{ $t("creditTitle") }}</p>
      <!-- banner1开始 -->
      <el-carousel :height="bannerHeight + 'px'" :interval="28000">
        <el-carousel-item>
          <div class="banner1" id="demo">
            <div class="first" ref="container">
              <div class="first-head">
                <div class="first-left">
                  <img src="../../assets/image/footer-logo.png" alt="" />
                  <p>Credit Report</p>
                </div>
                <div class="first-right">
                  <p>Nama Akun: Tina</p>
                  <p>Tanggal Laporan: 2021-09-10</p>
                  <p>ID Laporan:202109101127Tina6238</p>
                </div>
              </div>
            </div>
            <div class="line"></div>
            <!-- 1-1 -->
            <div class="first1">
              <p class="little-title">Informasi Subyek</p>
              <div class="content">
                <div class="cont-box">
                  <div class="box">
                    <p>Nama: MISBAHUDIN</p>
                    <p>NIK: 3203081706900011</p>
                    <p>Tanggal Lahir: 1990-10-15</p>
                  </div>
                  <div class="box">
                    <p>Alamat: 006/008 NYLINDUNG CUGENANG</p>
                    <p>Tujuan Pinjaman: Untuk Pinjaman</p>
                    <p>Tanggal Permintaan: 2019-09-10 11:27</p>
                  </div>
                  <div class="box">
                    <!-- <p>Username: Mario</p> -->
                  </div>
                </div>
                <p>
                  Informasi yang disajikan berdasarkan data yang diberikan oleh pelapor
                  berdasarkan kata kunci pencarian.
                </p>
              </div>
            </div>
            <div class="line"></div>
            <!-- 1-2 -->
            <div class="first2">
              <p class="little-title">Informasi Sosial</p>
              <div class="three-line">
                <p>WhatsApp</p>
                <p class="three-right">080510155362</p>
              </div>
              <div class="three-line top-line">
                <p>Aktivitas Whatsapp</p>
                <p class="three-right">10 jam seminggu</p>
              </div>
              <div class="three-line no-line">
                <p>Facebook</p>
                <p class="three-right">0811101212</p>
              </div>
              <div class="three-line bottom-line">
                <p>Aktivitas Facebook</p>
                <p class="three-right">10 jam seminggu</p>
              </div>
            </div>
          </div>
        </el-carousel-item>
        <!-- banner1结束 -->
        <!-- 1-3 -->
        <!-- banner2开始 -->
        <el-carousel-item>
          <div class="banner2">
            <div class="title">
              <p style="fontsize: 30px; margin-Top: 16px; margin-Bottom:18px">Dashboard</p>
            </div>
            <div class="line"></div>
            <div class="first3">
              <p class="little-title">Seeder Score（SS）</p>
              <div class="first3-1">
                <div class="four">
                  <div class="four-box">
                    <div class="four-circle">B</div>
                    <p>Tingkat Resiko</p>
                  </div>
                  <div class="four-box">
                    <div class="four-circle circle-two"></div>
                    <p>Pendapatan Bulanan: 6,600,000 IDR</p>
                  </div>
                </div>
                <div class="four">
                  <div class="four-box">
                    <div class="four-circle circle-three"></div>
                    <p>Deskripsi Trend: Flat</p>
                  </div>
                  <div class="four-box">
                    <div class="four-circle circle-four">736</div>
                    <p>Skor Seeder</p>
                  </div>
                </div>
              </div>
              <p class="xie">
                <i>*A [750-950] Sangat Bagus; B [650-750] Bagus;C [600-650] Baik;D
                  [550-600] Sedang;E [350-550] Buruk.
                  Semakin Tinggi Nilai Skor, Semakin Baik Kualitas Hasil Laporan
                  Kredit</i>
              </p>
              <!-- <p class="xie"><i></i></p> -->
            </div>
            <div class="line"></div>
            <div class="first3">
              <p class="little-title">Permintaan Informasi</p>
              <div class="four-box">
                <div class="four-circle circle-three">3</div>
                <p>Jumlah permintaan informasi dalam 12 bulan terakhir</p>
              </div>
              <div class="four-box">
                <div class="four-circle circle-four">2</div>
                <p>Pencarian pelanggan selama 12 bulan terakhir</p>
              </div>
            </div>
          </div>
        </el-carousel-item>

        <!-- banner2结束 -->
        <!-- 3 -->
        <el-carousel-item>
          <div class="thirdly">
            <div class="title">
              <!-- <div class="wire">
            <img src="../../assets/image/left.png" alt="" />
          </div> -->
              <p>Informasi Pinjaman</p>
              <!-- <div class="wire">
            <img src="../../assets/image/right.png" alt="" />
          </div> -->
            </div>
            <!-- <div class="line"></div> -->
            <table border="1">
              <tr>
                <th>Nomor</th>
                <th>Tanggal Pinjaman</th>
                <th>Jumlah Pinjaman</th>
                <th>Penggunaan Pinjaman</th>
                <th>Tanggal Pembayaran</th>
                <th>Terlambat</th>
              </tr>
              <tr>
                <td>1</td>
                <td>2021-08-10</td>
                <td>1,200,000</td>
                <td>Beli Ponsel</td>
                <td>2021-08-18</td>
                <td>YA</td>
              </tr>
              <tr>
                <td>2</td>
                <td>2021-07-22</td>
                <td>1,000,000</td>
                <td>Beli Jam Tangan</td>
                <td>2021-07-30</td>
                <td>Tidak</td>
              </tr>
              <tr>
                <td>3</td>
                <td>2021-07-04</td>
                <td>1,100,000</td>
                <td>Beli Komputer</td>
                <td>2021-07-12</td>
                <td>Tidak</td>
              </tr>
              <tr>
                <td>4</td>
                <td>2021-06-15</td>
                <td>400,000</td>
                <td>Beli Sepeda</td>
                <td>2021-06-23</td>
                <td>Tidak</td>
              </tr>
              <tr>
                <td>5</td>
                <td>2021-04-11</td>
                <td>300,000</td>
                <td>Beli Headset Tanpa Wayar</td>
                <td>2021-04-19</td>
                <td>Tidak</td>
              </tr>
              <tr>
                <td>6</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
              </tr>
              <!-- <tr>
                <td>7</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
              </tr>
              <tr>
                <td>8</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
                <td>…</td>
              </tr> -->
            </table>
          </div>
          <div class="fifth">
            <div class="title">
              <!-- <div class="wire">
            <img src="../../assets/image/left.png" alt="" />
          </div> -->
              <p>Memuatkan Ulang Komunikasi</p>
              <!-- <div class="wire">
            <img src="../../assets/image/right.png" alt="" />
          </div> -->
            </div>
            <!-- <div class="line"></div> -->
            <table border="1">
              <tr>
                <th>Nomor</th>
                <th>Nomor Telepon</th>
                <th>Jumlah Muat Ulang(IDR)</th>
                <th>Tanggal</th>
              </tr>
              <tr>
                <td>1</td>
                <td>081212305122</td>
                <td>22,000</td>
                <td>2021-08-12</td>
              </tr>
              <tr>
                <td>2</td>
                <td>081212305122</td>
                <td>10,000</td>
                <td>2021-06-29</td>
              </tr>
              <tr>
                <td>3</td>
                <td>081212305122</td>
                <td>30,000</td>
                <td>2021-04-02</td>
              </tr>
              <tr>
                <td>4</td>
                <td>0805109949</td>
                <td>12,000</td>
                <td>2021-03-18</td>
              </tr>
              <tr>
                <td>5</td>
                <td>805109949</td>
                <td>20,000</td>
                <td>2021-02-10</td>
              </tr>
              <tr>
                <td>6</td>
                <td>805109949</td>
                <td>15,000</td>
                <td>2020-12-27</td>
              </tr>
            </table>
          </div>
        </el-carousel-item>
        <!-- 4 -->
        <el-carousel-item>
          <div class="fourthly">
            <div class="title">
              <!-- <div class="wire">
            <img src="../../assets/image/left.png" alt="" />
          </div> -->
              <p>Informasi Beberapa Pinjaman</p>
              <!-- <div class="wire">
            <img src="../../assets/image/right.png" alt="" />
          </div> -->
            </div>
            <!-- <div class="line"></div> -->
            <!-- <div class="table"> -->
            <table border="1">
              <tr>
                <th>Nomor</th>
                <th>Harian</th>
                <th>Kondisi Kueri</th>
                <th>Frekuensi</th>
              </tr>
              <tr>
                <td>1</td>
                <td>7</td>
                <td>KTP</td>
                <td>1</td>
              </tr>
              <tr>
                <td>2</td>
                <td>14</td>
                <td>KTP</td>
                <td>3</td>
              </tr>
              <tr>
                <td>3</td>
                <td>21</td>
                <td>KTP</td>
                <td>5</td>
              </tr>
              <tr>
                <td>4</td>
                <td>30</td>
                <td>KTP</td>
                <td>8</td>
              </tr>
              <tr>
                <td>5</td>
                <td>60</td>
                <td>KTP</td>
                <td>10</td>
              </tr>
              <tr>
                <td>6</td>
                <td>90</td>
                <td>KTP</td>
                <td>12</td>
              </tr>
              <tr>
                <td>7</td>
                <td>730</td>
                <td>KTP</td>
                <td>30</td>
              </tr>
              <!-- <tr>
                <th>Nomor</th>
                <th>Harian</th>
                <th>Kondisi Kueri</th>
                <th>Frekuensi</th>
              </tr> -->
              <tr>
                <td>1</td>
                <td>7</td>
                <td>Nomor Telepon</td>
                <td>1</td>
              </tr>
              <tr>
                <td>2</td>
                <td>14</td>
                <td>Nomor Telepon</td>
                <td>1</td>
              </tr>
              <tr>
                <td>3</td>
                <td>21</td>
                <td>Nomor Telepon</td>
                <td>2</td>
              </tr>
              <tr>
                <td>4</td>
                <td>30</td>
                <td>Nomor Telepon</td>
                <td>4</td>
              </tr>
              <tr>
                <td>5</td>
                <td>60</td>
                <td>Nomor Telepon</td>
                <td>5</td>
              </tr>
              <tr>
                <td>6</td>
                <td>90</td>
                <td>Nomor Telepon</td>
                <td>7</td>
              </tr>
              <tr>
                <td>7</td>
                <td>730</td>
                <td>Nomor Telepon</td>
                <td>10</td>
              </tr>
            </table>
            <!-- <table border="1">
              
              
            </table> -->
            <!-- </div> -->
            <i>
              *Frekuensi Jumlah Pengajuan kepada Instansi Pinjaman Berdasarkan
              Keterangan Data Tertentu dan Dalam Siklus Periode “A-Day Terakhir”,
              A Adalah Kelompok Jumlah Hari Pada Tabel.
            </i>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <!-- 5 -->
          <div class="fifth">
            <div class="title">
              <!-- <div class="wire">
            <img src="../../assets/image/left.png" alt="" />
          </div> -->
              <p>Catatan Isi Ulang</p>
              <!-- <div class="wire">
            <img src="../../assets/image/right.png" alt="" />
          </div> -->
            </div>
            <!-- <div class="line"></div> -->
            <table border="1">
              <tr>
                <th>Nomor</th>
                <th>Nomor Telepon</th>
                <th>Jumlah Muat Ulang(IDR)</th>
                <th>Tanggal</th>
              </tr>
              <tr>
                <td>1</td>
                <td>081236305362</td>
                <td>22,000</td>
                <td>2021-08-12</td>
              </tr>
              <tr>
                <td>2</td>
                <td>081236305362</td>
                <td>10,000</td>
                <td>2021-06-29</td>
              </tr>
              <tr>
                <td>3</td>
                <td>081236305362</td>
                <td>30,000</td>
                <td>2021-04-02</td>
              </tr>
              <tr>
                <td>4</td>
                <td>0811109949</td>
                <td>12,000</td>
                <td>2021-03-18</td>
              </tr>
              <tr>
                <td>5</td>
                <td>811109949</td>
                <td>20,000</td>
                <td>2021-02-10</td>
              </tr>
              <tr>
                <td>6</td>
                <td>811109949</td>
                <td>15,000</td>
                <td>2020-12-27</td>
              </tr>
            </table>
          </div>
          <div class="sixth">
            <div class="title">
              <!-- <div class="wire">
            <img src="../../assets/image/left.png" alt="" />
          </div> -->
              <p>BPJS Ketenagakerjaan</p>
              <!-- <div class="wire">
            <img src="../../assets/image/right.png" alt="" />
          </div> -->
            </div>
            <!-- <div class="line"></div> -->
            <table border="1">
              <tr>
                <th>BPJS</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td>Nama</td>
                <td>Muhkori</td>
                <td>ID BPJS </td>
                <td>1053112302</td>
              </tr>
              <tr>
                <td>Nomor Identitas</td>
                <td>3203111706966611</td>
                <td>Tanggal Terdaftar</td>
                <td>2016-06-01</td>
              </tr>
              <tr>
                <td>Tanggal Lahir</td>
                <td>1990-10-15</td>
                <td>Masa Kepesertaan</td>
                <td>2 Tahun 2 Bulan</td>
              </tr>
              <tr>
                <td>Tangal Non Aktif</td>
                <td>3000-12-31</td>
                <td>Lama Tunggakan</td>
                <td>Tidak Ada</td>
              </tr>
              <tr>
                <td>Alamat Tenaga Kerja</td>
                <td>006/008 NYLINDUNG CUGENANG</td>
                <td>Status Klaim</td>
                <td>Belum Klaim</td>
              </tr>
              <tr>
                <td>Nama Perusahaan</td>
                <td>PT Bank OCBC</td>
                <td>Alamat Kantor</td>
                <td>JI.Mawar no.18,Medan</td>
              </tr>
              <tr>
                <td>Tahun</td>
                <td>2021</td>
                <td>Bulan</td>
                <td>09</td>
              </tr>
            </table>
          </div>
        </el-carousel-item>
        <!-- 6 -->
        <!-- <el-carousel-item>
          <div class="sixth">
            <div class="title">
            
              <p>BPJS Ketenagakerjaan</p>
              
            </div>
            <div class="line"></div>
            <table border="1">
              <tr>
                <th>BPJS</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td>Nama</td>
                <td>TETEP MISBAHUDIN</td>
                <td>BPJSID</td>
                <td>1053207031</td>
              </tr>
              <tr>
                <td>Nomor Identitas</td>
                <td>3203111706900011</td>
                <td>Tanggal Kepesertaan</td>
                <td>2016-06-01</td>
              </tr>
              <tr>
                <td>Tanggal Lahir</td>
                <td>1990-06-17</td>
                <td>Masa Kepesertaan</td>
                <td>2 Tahun 2 Bulan</td>
              </tr>
              <tr>
                <td>Tangal Non Aktif</td>
                <td>3000-12-31</td>
                <td>Lama Tunggakan</td>
                <td>Tidak Ada</td>
              </tr>
              <tr>
                <td>Alamat Tenaga Kerjia</td>
                <td>003/006 NYLINDUNG CUGENANG</td>
                <td>Status Klaim</td>
                <td>Belum Klaim</td>
              </tr>
              <tr>
                <td>Nama Perusahaan</td>
                <td>PT Bank OCBC NISP</td>
                <td>Alamat Kantor</td>
                <td>JI.Mawar no.17,Medan</td>
              </tr>
              <tr>
                <td>Tuhun</td>
                <td>2021</td>
                <td>Bulun</td>
                <td>09</td>
              </tr>
            </table>
          </div>
        </el-carousel-item> -->
      </el-carousel>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default {
  name: "Risk",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      launage: "",
      fixedHeader: false,
      num: 0,
      bannerHeight: 656,
      // imgObj: {
      //   preLoad: 1,
      //   loading: require("../../assets/image/riskImage/fk-loading.jpg"),
      //   src: require("../../assets/image/riskImage/fkBanner.png"),
      //   error: require("../../assets/image/error.jpg"),
      // },
      // imgUrl: "http://xx.com/logo.png", // String
    };
  },
  computed: {
    imgObj() {
      if (this.launage === "en_US") {
        return {
          preLoad: 1,
          loading: require("../../assets/image/zhinengdaoliu/zh-loading.png"),
          src: require("../../assets/image/zhinengdaoliu/znBanner.png"),
          error: require("../../assets/image/error.jpg"),
        };
      } else {
        return {
          preLoad: 1,
          loading: require("../../assets/zhImage/compress_cn/znBanner-zh.png"),
          src: require("../../assets/zhImage/znBanner-zh.png"),
          error: require("../../assets/image/error.jpg"),
        };
      }
    },
  },
  mounted() {
    window.addEventListener(
      "resize",
      () => {
        var div = document.getElementById('demo');
            console.log(div.offsetHeight); // 224
        this.bannerHeight = div.offsetHeight.height
        // console.log(this.$refs.bannerHeight[0], ">>>>>");
        this.bannerHeight = div.offsetHeight
        ? div.offsetHeight.height
        : 656;
        // this.imgLoad();
      },
      false
    );
  },
  created() {
    this.launage = this.$i18n.locale;
    //获取滚动条高度处理头部导航
    window.onscroll = () => {
      // console.log(e)
      this.fixedHeader = document.documentElement.scrollTop >= 60;
    };
  },
};
</script>
<style lang="less" scoped>
.wrap {
  width: 100%;
  .fixedHeader {
    position: fixed;
    background: black;
  }
  .absolute {
    position: absolute;
  }
}
.banner {
  width: 100%;
  //   min-height: 400px;
  img {
    width: 100%;
    // min-width: 1200px;
  }
}
.title {
  margin: auto;
  font-size: 22px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgb(32, 56, 100);
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-bottom: 8px;
  .wire {
    margin-left: 20px;
    margin-right: 20px;
  }
}
.line {
  width: 100%;
  height: 3px;
  background: rgba(68, 113, 196);
}
table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0px;
  border: 1px solid rgba(68, 113, 196);
  margin-bottom: 12px;
  th {
    background: rgba(68, 113, 196);
    color: #fff;
    font-size: 18px;
    padding: 2px 20px;
  }
  th,
  td {
    border: 1px solid #bbb;
    text-align: center;
    height: 32px;
  }
  td {
    font-size: 16px;
    border: 0px;
    border-bottom: 1px solid rgba(68, 113, 196);
  }
}
.little-title {
  font-size: 18px;
  color: rgba(31, 56, 99);
  font-weight: bold;
  margin-bottom: 10px;
}
.main {
  width: 1200px;
  font-size: 16px;
  // background: red;
  margin: auto;
  .credit-title{
    font-size: 22px;
    // background: rgba(31, 56, 99);
    background: rgba(217, 226, 243);
    color: rgba(68, 113, 196);
    margin: 24px 0px 10px;
    padding: 20px;
    box-sizing: border-box;
    font-weight: bold;
    border-radius: 10px;
  }
  //第一
  .first {
    // background: pink;
    width: 100%;
    padding-top: 30px;
    padding-bottom: 18px;
    .first-left {
      // width: 160px;
      text-align: center;
      p {
        text-align: left;
      }
    }
    .first-head {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      color: rgba(47, 85, 151);
      font-size: 18px;
      .first-right {
        text-align: right;
        line-height: 32px;
      }
    }
  }
  //1-1
  .first1 {
    width: 100%;
    // padding-top: 38px;
    // padding-bottom: 38px;
    padding: 24px 18px;
    .content {
      line-height: 30px;
      color: rgba(47, 85, 151);
      .cont-box {
        display: flex;
        .box {
          margin-right: 150px;
        }
      }
    }
  }
  //1-2
  .first2 {
    padding: 24px 18px;
    margin-bottom: 40px;
    .three-line {
      width: 100%;
      height: 40px;
      border-top: 2px solid rgba(68, 113, 196);
      display: flex;
      align-items: center;
      color: rgba(68, 113, 196);
      p {
        width: 50%;
        padding-left: 4px;
      }
    }
    .three-right {
      height: 60px;
      color: #000;
      line-height: 60px;
    }
    .top-line {
      background: rgba(217, 226, 243);
    }
    .no-line {
      border: none;
    }
    .bottom-line {
      border-top: none;
      border-bottom: 2px solid rgba(68, 113, 196);
      background: rgba(217, 226, 243);
    }
  }
  // 1-3
  .first3 {
    padding: 24px 18px;
    .four-box {
      height: 84px;
      display: flex;
      align-items: center;
      .four-circle {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: rgba(192, 0, 0);
        color: #fff;
        line-height: 60px;
        text-align: center;
        font-weight: bold;
      }
      P {
        color: rgb(32, 56, 100);
        margin-left: 30px;
      }
      .circle-two {
        background: rgb(132, 60, 12);
      }
      .circle-three {
        background: rgb(84, 130, 53);
      }
      .circle-four {
        background: rgb(68, 114, 196);
      }
    }
    .xie {
      color: rgba(31, 56, 99);
      font-size: 18px;
      margin-top: 14px;
    }

    .first3-1 {
      display: flex;
      justify-content: space-between;
      .four {
        margin-right: 160px;
      }
    }
  }
  //第三
  .thirdly {
    padding-top: 14px;
  }
  //第四
  .fourthly {
    width: 100%;
    padding: 14px 0px;
    box-sizing: border-box;
    i {
      font-size: 18px;
      color: rgba(31, 56, 99);
    }
  }
  //第五
  .fifth {
    width: 100%;
    // padding-top: 30px;
    .title{
      margin-top: 12px;
    }
  }
  //第六
  .sixth {
    width: 100%;
    // padding-top: 30px;
    padding-bottom: 38px;
    
    th,
    td {
      border: 1px solid #fff;
      text-align: center;
      height: 34px;
    }
    td,
    th {
      padding: 4px 20px;
      box-sizing: border-box;
      line-height: 24px;
    }
    th {
      border: 0;
    }
    tr:nth-of-type(odd) {
      background: rgba(233, 235, 245);
    }
    tr:nth-of-type(even) {
      background: rgba(207, 212, 234);
    }
  }
  //第七
  .seventh {
    margin-bottom: 166px;
    p {
      width: 97%;
      font-size: 20px;
      margin-bottom: 20px;
      color: rgba(31, 56, 99);
      margin: 14px auto 20px;
      line-height: 1.8;
    }
  }
}
</style>